export default __webpack_public_path__ + "assets/models/bce63960760849615ecaadc2517f0184.glb";